import script from "./StorageBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./StorageBar.vue?vue&type=script&setup=true&lang=ts"

import "./StorageBar.vue?vue&type=style&index=0&id=b1fb80fa&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1fb80fa"]])

export default __exports__